import type { DataflowSummary } from "../types/dataflows";

/**
 * #2521: a confirmed destination move (`resetBounds`, round 9 B-02) cleared the connection's load
 * bounds (`boundsResetAt`) and no table has landed in the new place yet. The connection imported
 * before, so it reads everything again because of the move, never as a first import. Once the next
 * import lands a table (`hasLanded`) the ordinary notes decide again.
 */
export function readsAgainAfterMove(
  connection: Pick<DataflowSummary, "lastRefreshAt"> &
    Partial<Pick<DataflowSummary, "hasLanded" | "boundsResetAt">>,
): boolean {
  return (
    connection.lastRefreshAt === null &&
    connection.hasLanded !== true &&
    typeof connection.boundsResetAt === "string" &&
    connection.boundsResetAt !== ""
  );
}
